import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { HOST } from '../utils/constants.ts';
import AuthLayout from './AuthLayout.tsx';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) return toast.error('Ingresa tu email');

    try {
      const res = await fetch(`${HOST}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) {
        let errorMessage = 'Error al enviar email';
        try {
          const err = await res.json();
          errorMessage = err.message || errorMessage;
        } catch {
          errorMessage =
            'El servidor no está disponible. Intenta de nuevo más tarde.';
        }
        throw new Error(errorMessage);
      }

      toast.success(
        'Te enviamos un correo con instrucciones para restablecer tu contraseña.'
      );
      navigate('/');
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const returnToLogin = () => {
    navigate('/login');
  };

  return (
    <AuthLayout>
      <h2>Recuperar Contraseña</h2>
      <form onSubmit={(e) => e.preventDefault()}>
        <label htmlFor="email">Correo electrónico</label>
        <input
          type="email"
          id="email"
          placeholder="Ingresá tu email"
          className="input-button"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <div className="button-separation">
          <button onClick={returnToLogin} className="primary-button">
            Volver a iniciar Sesión
          </button>
          <button className="primary-button" onClick={handleSubmit}>
            Enviar email de recuperación
          </button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;
